export default "__VITE_ASSET__IvlyDGbU__"